export enum EditAction {
    ADD_VERTEX = "ADD_VERTEX",
    REMOVE_VERTEX = "REMOVE_VERTEX",
    MOVE_FEATURE = "MOVE_FEATURE",
    FOLLOW_GEO_BORDER = "FOLLOW_GEO_BORDER",
    TO_GREAT_CIRCLE = "TO_GREAT_CIRCLE",
    ARC_BY_EDGE = "ARC_BY_EDGE",
    ARC_BY_ANGLES = "ARC_BY_ANGLES",
    NONE = "NONE",
}
